import { SONGS } from '../constants/wordlist'
import { format } from 'date-fns'
import { SONGDATA } from '../constants/songData'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import { CARDS } from '../constants/cards'
import { getCardsSequence } from './localStorage'

export const isWinningSong = (word: string) => {
  return word === solution
}

export const getWordOfDay = () => {
  const cardSequence = getCardsSequence()
  const epochMs = new Date('March 21, 2022 00:00:00')
  const utcEpoch = zonedTimeToUtc(epochMs, 'Asia/Tokyo')
  const current = new Date()
  const kst = utcToZonedTime(current, 'Asia/Tokyo')
  const utcKST = zonedTimeToUtc(kst, 'Asia/Tokyo')
  const date = format(current, 'yy/MM/dd')
  const msInDay = 86400000
  const index = Math.floor((utcKST.valueOf() - utcEpoch.valueOf()) / msInDay)
  const nextday = (index + 1) * msInDay + utcEpoch.valueOf()
  const solution = SONGS[index % SONGS.length]
  const song = SONGDATA.filter((s) => s.name == solution)[0];
  const cardDate = new Date('April 15, 2022 00:00:00')
  const kstCardDate = utcToZonedTime(cardDate, 'Asia/Tokyo')
  const utcKSTCardDate = zonedTimeToUtc(kstCardDate, 'Asia/Tokyo')
  const cardDelay = Math.floor((utcKSTCardDate.valueOf() - utcEpoch.valueOf()) / msInDay)
  const cardOfTheDay = cardSequence && CARDS[cardSequence[index-cardDelay]-1]

  return {
    solution: solution,
    song: song,
    solutionIndex: index + 1,
    tomorrow: nextday,
    date: date,
    cardOfTheDay: cardOfTheDay,
    cardIndex: index-cardDelay
  }
}

export const { solution, solutionIndex, tomorrow, date, song, cardOfTheDay, cardIndex } = getWordOfDay()
